import type { Distance } from "@pdfking/math"
import { Max } from "@pdfking/math"

import type { GrowSize } from "#internal"

export type BoxVariables = {
  h: Distance
  w: Distance
  d: Distance
  s: Distance
}

export const ExtractVariables = (
  size: GrowSize,
  opts: {
    min_w?: Distance
    min_h?: Distance
    min_d?: Distance
    min_s?: Distance
  } = {}
): BoxVariables =>
  ({
    w: Max(size.width, opts.min_w ?? 0),
    h: Max(size.height, opts.min_h ?? 0),
    d: Max(size.depth, opts.min_d ?? 0),
    s: Max(size.sheet_depth, opts.min_s ?? 0),
  }) as BoxVariables
